<template>
  <section>
    <div class="row ps-5 justify-content-center">
      <div class="col-10">
        <!--Protocol and Instructions -->
        <div class="row">
          <div class="col-4 custom-protocol">
            <div class="form-group row custom-protocol-type">
              <label for="protocolType" class="control-label"
                >Select a Protocol</label
              >
              <select
                name="protocolType"
                class="form-select"
                v-model="protocol"
                :disabled="isStarted"
                @change="selectedProtocol"
              >
                <option
                  v-for="item of protocolTypes"
                  :key="item.id"
                  :value="item.value"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <!-- <z-select
              v-model="protocol"
              :options="protocolTypes"
              :disabled="isStarted"
              label="Select a Protocol"
              @change="selectedProtocol"
            /> -->
            <button
              v-show="gotAssessment"
              class="btn btn-link custom-instructions"
              @click="getInstructions"
            >
              Instructions
            </button>
          </div>
          <div class="col-4">
            <!-- Action Buttons -->
            <div v-show="gotAssessment" class="row custom-actions-wrapper">
              <div class="col custom-actions">
                <button
                  class="btn btn-primary btn ms-2"
                  :disabled="isContinue"
                  @click="pairDevice"
                >
                  Pair
                </button>
                <button
                  :disabled="!isPaired || isStarted"
                  class="btn btn-primary btn ms-2"
                  @click="captureData"
                >
                  Start
                </button>
                <button
                  :disabled="!isContinue || !isPaired || !isStarted"
                  class="btn btn-primary btn ms-2"
                  @click="stopTest"
                >
                  Finish
                </button>
                <button
                  :disabled="!isContinue"
                  class="btn btn-primary btn ms-2"
                  @click="cancelTest(true)"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="custom-stopwatch">
              <!-- Heartrate and Stopwatch -->
              <div
                v-show="gotAssessment && isPaired && !stopListening"
                class="custom-time-wrapper"
              >
                <div class="custom-heartrate-wrapper">
                  <div class="custom-heartrate">
                    <i class="fas fa-heartbeat fa-pulse custom-heart"></i>
                    <span>{{ results.heartrate }} bpm</span>
                  </div>
                </div>
                <div v-show="isStarted" class="custom-time">
                  {{ stopwatch.etime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- HR Graph and Results -->
    <div class="row p-3 justify-content-center">
      <div class="col-9">
        <z-tabs
          ref="tabber"
          v-model="currentTab"
          :tabs="tabs"
          @change="showTab"
        />
      </div>
    </div>
    <div class="row p-3" v-if="currentTab === 'Heartrate'">
      <div class="col-12">
        <!-- HR Graph -->
        <div class="row justify-content-center">
          <div class="col-9 custom-chart">
            <heartrate-chart :hrData="hrData" />
          </div>
        </div>
      </div>
    </div>
    <div class="row p-3" v-if="currentTab === 'Results'">
      <div class="col-12">
        <!-- Results -->
        <div v-if="isCalculated" class="row justify-content-center">
          <div class="col-6">
            <div class="row">
              <div class="col-1 mt-4">
                <!-- <button class="btn btn-link" @click="showNorms">norms</button> -->
              </div>
              <div class="col">
                <div class="custom-vo2-title">
                  <span>VO2 Max Results:</span>
                </div>
                <div class="custom-vo2-results">
                  <span>Your Score:</span
                  ><span class="ms-2"
                    >{{ formatVO2(results.vo2) }} mL/kg/min</span
                  >
                </div>
                <div class="custom-vo2-results">
                  <span>Ranking:</span
                  ><span class="ms-2">{{ rankSetting }}</span>
                </div>
              </div>
            </div>
            <div class="row justify-content-center custom-table-scale">
              <table>
                <thead>
                  <tr>
                    <th v-for="(item, idx) of rankNorm" :key="idx">
                      {{ item.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="(item, idx) of rankNorm" :key="idx">
                      {{ item.scale }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row justify-content-center">
              <div class="col-2 mt-4">
                <!-- <button
                  v-show="!isSaved"
                  class="btn btn-primary"
                  :disabled="isSaving"
                  @click="save"
                >
                  <i v-if="isSaving" class="fas fa-spinner fa-spin"></i>
                  Save
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <instructions-dialog :show="actionInstructions" @close="closeModal" />
    <norms-dialog :show="actionNorms" @close="closeModal" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZSelect from '@/Components/ZElements/Select'
import ZTabs from '@/Components/ZElements/Tabs'
import HeartrateChart from './heartrate-chart'
import InstructionsDialog from './instructions-dialog'
import NormsDialog from './norms-dialog'
import moment from 'moment'
export default {
  name: 'heart-monitor-assessment',
  components: {
    ZSelect,
    ZTabs,
    HeartrateChart,
    InstructionsDialog,
    NormsDialog,
  },
  data() {
    return {
      currentTab: 'Heartrate',
      startingHR: null,
      hrArraySize: 600,
      hrData: null,
      hrTick: 0,
      channel: null,
      isStarted: false,
      stopwatch: {
        etime: '00:00:00', // html time display
        timer: null, // timer object
        now: 0, // current elapsed time
      },
      pulse: null,
      results: {
        assessmentType: null,
        firstHR: 0,
        lastHR: 0,
        avgHR: 0,
        maxHR: 0,
        vo2: 0,
        duration: 0,
        heartrate: 0,
      },
      rankSetting: null,
      rankNorm: [],
      isContinue: false,
      isCalculated: false,
      protocol: null,
      gotAssessment: false,
      isPaired: false,
      actionInstructions: null,
      actionNorms: null,
      pill: 'Assessment',
      dontCalculate: false,
      stopListening: false,
      isSaved: false,
      isSaving: false,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('configuration', [
      'assessmentNorms',
      'assessment',
      'assessments',
    ]),
    ...mapGetters('usercardio', ['member']),
    tabs() {
      let _tabs = ['Heartrate', 'Results']
      return _tabs
    },
    protocolTypes() {
      let _types = []
      if (this.assessments) {
        this.assessments.forEach((element) => {
          if (element.assessmentName === 'VO2 Max') {
            _types.push({
              id: element.id,
              name: element.testType,
              value: element.id,
            })
          }
        })
      }
      return _types
    },
    normsMen() {
      let _data = null
      if (this.assessmentNorms) {
        let found = this.assessmentNorms.find((x) => x.Value === 'Men')
        if (found) {
          _data = JSON.parse(found.TextValue)
        }
      }
      return _data
    },
    normsWomen() {
      let _data = null
      if (this.assessmentNorms) {
        let found = this.assessmentNorms.find((x) => x.Value === 'Women')
        if (found) {
          _data = JSON.parse(found.TextValue)
        }
      }
      return _data
    },
    memberAge() {
      let _age = null
      if (this.member) {
        _age = parseInt(this.member.age)
      }
      return _age
    },
    memberWeight() {
      let _value = ''
      if (this.member) {
        _value = parseFloat(this.member.viewWeight)
      }
      return _value
    },
    memberHeight() {
      let _value = ''
      if (this.member) {
        _value = parseFloat(this.member.viewHeight)
      }
      return _value
    },
    memberGender() {
      let _gender = null
      if (this.member) {
        _gender = this.member.gender.toLowerCase()
      }
      return _gender
    },
  },
  methods: {
    ...mapActions('configuration', ['getAssessment', 'getAssessments']),
    ...mapActions('measurements', ['saveVO2assessment']),
    init() {
      this.dontCalculate = false
      this.stopListening = false
      this.hrData = new Array(this.hrArraySize).fill(this.startingHR)
      this.getAssessments()
      this.channel = Echo.join('direct').listenForWhisper('heartrate', (e) => {
        this.pulse = e
        // check to see if current user to take action on
        if (parseInt(this.pulse.userId) === parseInt(this.member.id)) {
          this.isPaired = true
          if (this.pulse.action === 'start' && !this.stopListening) {
            this.stopListening = false
            this.isCalculated = false
            // if a "start", then kick off the timer and initialize HR data array
            if (this.stopwatch.timer === null) {
              this.stopwatch.now = -1
              this.tick()
              this.stopwatch.timer = setInterval(this.tick, 1000)
              this.results = {
                assessmentType: null,
                firstHR: 0,
                lastHR: 0,
                avgHR: 0,
                maxHR: 0,
                vo2: 0,
                duration: 0,
                heartrate: 0,
              }
              this.hrData = Array(this.hrArraySize).fill(this.startingHR)
              this.hrTick = 0
            }
            if (this.isStarted) {
              // if started, show data on graph
              if (this.hrTick < this.hrArraySize) {
                this.hrTick++
              } else {
                this.hrTick = this.hrData.length
              }
              this.hrData[this.hrTick] = parseInt(this.pulse.data)
              this.hrData = this.hrData.slice(-1 * this.hrArraySize)
            }
            // capture data for display
            this.results = {
              assessmentType: this.protocol,
              firstHR:
                this.results.firstHR !== 0
                  ? this.results.firstHR
                  : parseInt(this.pulse.data),
              lastHR: parseInt(this.pulse.data),
              avgHR: 0,
              maxHR: 0,
              vo2: 0,
              duration: this.stopwatch.now,
              heartrate: parseInt(this.pulse.data),
            }
          } else if (this.pulse.action === 'stop2') {
            this.cancelTest(false)
          } else if (this.pulse.action === 'stop') {
            // if a "stop", clear the timer and stop listening
            this.isStarted = false
            this.stopListening = true
            clearInterval(this.stopwatch.timer)
            this.stopwatch.timer = null
            if (!this.dontCalculate) {
              // if Finished, perform calculation and present the results
              this.calculateResults()
            }
          }
        }
      })
    },
    showTab(value) {
      this.currentTab = value
    },
    closeModal() {
      this.actionInstructions = null
      this.actionNorms = null
    },
    pairDevice() {
      // this initializes the Assessment App
      this.currentTab = 'Heartrate'
      this.isPaired = false
      this.$emit('statusSave', {
        start: false,
        isSaved: true,
        isSaving: false,
      })
      this.$refs.tabber.setVisibility({
        name: 'Results',
        isVisible: true,
      })
      let command = `nuvita://assessment/run/hrm?host=${window.socketUrl}&app_cluster=mt1&app_key=app-key&coach_user_id=${this.profile.id}&user_id=${this.member.id}`
      console.log('Pair Device', command)
      try {
        // window.location.replace(command)
        let result = window.open(command, '_blank')
        console.log('Launched App', result)
      } catch (e) {
        console.error('pairDevice', e)
      }
      this.isContinue = true
      this.dontCalculate = false
      this.stopListening = false
    },
    async selectedProtocol() {
      if (this.protocol) {
        // load up the Assessment info
        await this.getAssessment(this.protocol)
        this.gotAssessment = true
      }
    },
    getInstructions() {
      if (this.assessment) {
        this.actionInstructions = this.assessment
      }
    },
    showNorms() {
      if (this.assessment) {
        this.actionNorms = this.assessment
      }
    },
    tick() {
      // calculate hours, minutes, seconds
      this.stopwatch.now++
      let hours = 0,
        mins = 0,
        secs = 0,
        remain = this.stopwatch.now
      hours = Math.floor(remain / 3600)
      remain -= hours * 3600
      mins = Math.floor(remain / 60)
      remain -= mins * 60
      secs = remain
      // update the timer
      if (hours < 10) {
        hours = '0' + hours
      }
      if (mins < 10) {
        mins = '0' + mins
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      this.stopwatch.etime = `${hours}:${mins}:${secs}`
    },
    captureData() {
      // capture the data (i.e., "Start")
      this.currentTab = 'Heartrate'
      this.isStarted = true
      this.isContinue = true
      this.dontCalculate = false
      this.stopListening = false
      this.$emit('statusSave', {
        start: true,
        isSaved: true,
        isSaving: false,
      })
      this.$refs.tabber.setVisibility({
        name: 'Results',
        isVisible: false,
      })
      this.stopwatch.now = -1
      this.tick()
    },
    stopTest() {
      // stop the test (i.e., "Finish")
      this.isContinue = false
      this.stopListening = false
      this.dontCalculate = false
      this.isPaired = false
      this.$emit('statusSave', {
        start: false,
        isSaved: true,
        isSaving: false,
      })
      this.$refs.tabber.setVisibility({
        name: 'Results',
        isVisible: true,
      })
      // send a notice to the Assessment app to "stop"
      this.channel.whisper('heartrateaction', {
        userId: this.member.id,
        data: 0,
        action: 'stop',
        protocol: this.protocol,
      })
    },
    cancelTest(send) {
      // cancel the test (i.e., "Cancel")
      this.currentTab = 'Heartrate'
      this.isContinue = false
      this.stopListening = false
      this.dontCalculate = true
      this.isPaired = false
      this.isStarted = false
      this.$emit('statusSave', {
        start: false,
        isSaved: true,
        isSaving: false,
      })
      this.$refs.tabber.setVisibility({
        name: 'Results',
        isVisible: true,
      })
      // rest the timer and re-initialize the HR array
      this.stopwatch.now = -1
      this.tick()
      this.hrData = new Array(this.hrArraySize).fill(this.startingHR)
      if (send) {
        // send a notice to the Assessment app to "stop"
        this.channel.whisper('heartrateaction', {
          userId: this.member.id,
          data: 0,
          action: 'stop',
          protocol: this.protocol,
        })
      } else {
        this.stopListening = true
        clearInterval(this.stopwatch.timer)
      }
    },
    setRank(data) {
      // determine where the member "ranks" based upon final HR numbers
      this.rankSetting = null
      this.rankNorm = []
      let found = null
      // determine Gender array to use
      if (data.gender === 1) {
        found = this.normsWomen.find(
          (x) =>
            parseInt(this.memberAge) >= parseInt(x.age.start) &&
            parseInt(this.memberAge) <= parseInt(x.age.end)
        )
      } else {
        found = this.normsMen.find(
          (x) =>
            parseInt(this.memberAge) >= parseInt(x.age.start) &&
            parseInt(this.memberAge) <= parseInt(x.age.end)
        )
      }
      if (found) {
        for (var i = 0; i < found.age.scale.length; i++) {
          // capture Member's Ranking
          if (
            parseInt(data.vo2) >= parseInt(found.age.scale[i].start) &&
            parseInt(data.vo2) <= parseInt(found.age.scale[i].end)
          ) {
            this.rankSetting = found.age.scale[i].name
          }
          // set up Norms Scale
          let scale = ''
          if (found.age.scale[i].start === 0) {
            scale = `< ${found.age.scale[i].end}`
          } else if (found.age.scale[i].end === 9999) {
            scale = `> ${found.age.scale[i].start}`
          } else {
            scale = `${found.age.scale[i].start} - ${found.age.scale[i].end}`
          }
          this.rankNorm.push({
            name: found.age.scale[i].name,
            scale: scale,
          })
        }
      }
    },
    calculateResults() {
      // "Finished": calculate the results based upon Gender
      let vo2 = 0
      let gender = 0
      if (this.memberGender === 'female') {
        gender = 1
      }
      if (this.results) {
        let wt = this.memberWeight ? this.memberWeight : 0
        let age = this.memberAge ? this.memberAge : 0
        let duration = this.results.duration ? this.results.duration / 60 : 0
        let heartrate = this.results.heartrate ? this.results.heartrate : 0
        if (parseInt(this.results.assessmentType) === 1) {
          vo2 =
            132.853 -
            0.0769 * parseFloat(wt) -
            0.3877 * parseFloat(age) +
            6.315 * parseFloat(gender) -
            3.2649 * parseFloat(duration) -
            0.156 * parseFloat(heartrate)
        } else if (parseInt(this.results.assessmentType) === 2) {
          let offset = 108.844 // male
          if (gender === 1) {
            offset = 100.5
          }
          vo2 =
            offset -
            0.1636 * (parseFloat(wt) / 2.20462262) -
            1.438 * parseFloat(duration) -
            0.1928 * parseFloat(heartrate)
        } // others ...
        // vo2 in ml/kg/min
        this.results.vo2 = vo2.toFixed(1)
        let total = 0
        let cnt = 0
        if (this.hrData) {
          this.hrData.forEach((element) => {
            if (this.results.maxHR < parseInt(element)) {
              this.results.maxHR = parseInt(element)
            }
            if (parseInt(element) > (this.startingHR ? this.startingHR : 0)) {
              total += parseInt(element)
              cnt++
            }
          })
          if (cnt > 0) {
            this.results.avgHR = total / cnt
          }
        }
        // determine rank...
        this.setRank({
          gender: gender,
          vo2: vo2,
        })
        this.isCalculated = true
        this.isSaved = false
        this.$emit('statusSave', {
          start: false,
          isSaved: this.isSaved,
          isSaving: false,
        })
        this.currentTab = 'Results'
        console.log('Calc VO2 Assessment Results', {
          member: this.member,
          results: this.results,
          norms: this.assessmentNorms,
        })
      }
    },
    formatVO2(value) {
      let results = ''
      if (value) {
        results = parseFloat(value).toFixed(0)
      }
      return results
    },
    async save() {
      // save the VO2 Max results
      this.isSaving = true
      this.$emit('statusSave', {
        start: false,
        isSaved: this.isSaved,
        isSaving: this.isSaving,
      })
      let data = {
        userId: this.member.id,
        entryDate: moment().local().format('YYYY-MM-DD HH:mm:ss'),
        assessmentType: parseInt(this.results.assessmentType),
        firstHR: this.results.firstHR,
        lastHR: this.results.lastHR,
        avgHR: this.results.avgHR,
        maxHR: this.results.maxHR,
        vo2: parseFloat(this.results.vo2),
        duration: this.results.duration,
        age: this.memberAge ? this.memberAge : 0,
        weight: this.memberWeight ? this.memberWeight : 0,
        height: this.memberHeight ? this.memberHeight : 0,
      }
      console.log('Save VO2 Assessment Results', data)
      await this.saveVO2assessment(data)
      this.isSaving = false
      this.isSaved = true
      this.$emit('statusSave', {
        start: false,
        isSaved: this.isSaved,
        isSaving: this.isSaving,
      })
      this.cancelTest(true)
    },
  },
  // beforeUnmount() {
  //   Echo.leave('direct')
  // },
}
</script>
<style lang="scss" scoped>
.custom-stopwatch {
  display: inline-flex;
  height: 50px;
  position: relative;
  top: 10px;
}
.custom-time {
  font-size: 36px;
  font-weight: bold;
  margin-left: 32px;
}
.custom-actions-wrapper {
  position: relative;
  text-align: center;
}
.custom-actions {
  position: relative;
  top: 22px;
  button {
    width: 75px !important;
  }
}
.custom-protocol {
  position: relative;
  display: inline-flex;
}
.custom-protocol-type {
  width: 300px;
}
.custom-instructions {
  margin-left: 10px;
}
.custom-chart {
  text-align: center;
}
.custom-vo2 {
  padding-top: 100px;
  text-align: center;
  display: block;
  position: relative;
}
.custom-vo2-title {
  text-align: center;
  font-size: 1.3em;
  font-weight: 500;
}
.custom-vo2-results {
  text-align: center;
  margin-top: 15px;
  font-weight: 500;
  font-size: 1.1em;
}
.custom-table-scale2 {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  th,
  td {
    text-align: center;
  }
}
.custom-table-scale {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  table {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
    border: 1px solid;
    table-layout: fixed;
  }
  table th {
    border: 1px solid gray;
    padding: 4px;
    text-align: center;
  }
  table td {
    border: 1px solid gray;
    padding: 4px;
    text-align: center;
  }
}
.custom-time-wrapper {
  display: inline-flex;
}
.custom-heartrate-wrapper {
  position: relative;
}
.custom-heartrate {
  position: relative;
  top: 9px;
  width: 120px;
  span {
    font-size: 28px;
    font-weight: 500;
  }
}
.custom-heart {
  font-size: 1.2em;
  color: rgb(201, 0, 0);
  position: absolute;
  top: 0;
  left: -20px;
}
/* Icon pulse */
.fa-pulse {
  display: inline-block;
  -moz-animation: pulse 3s infinite linear;
  -o-animation: pulse 3s infinite linear;
  -webkit-animation: pulse 3s infinite linear;
  animation: pulse 3s infinite linear;
}

@-webkit-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
